import React, { Fragment, FunctionComponent, useEffect } from "react";

import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { thunkGetCategories } from "./umbraco/redux/catalog.actions";
import { thunkGetSiteSettings } from "./umbraco/redux/settings.actions";
import { thunkSetLocale } from "./umbraco/redux/page.actions";
import Footer from "../layout/Footer/Footer";
import Header from "../layout/Header/Header";
import MegaDropdown from "../layout/MegaDropdown/MegaDropdown";
import Sidemenu from "../layout/Sidemenu/Sidemenu";
import UmbracoPage from "./umbraco/pages/UmbracoPage";
import useTagManager from "./hooks/useTagManager";

import { thunkLoadDictionary } from "components/Dictionary/redux/dictionary.actions";
import { useDispatch, useSelector } from "react-redux";
import { DefaultRootState } from "react-redux";
import { AppThunkDispatch } from "app/redux-state.interface";
import MediaCloudOverlay from "pages/Catalog/components/MediaCloudOverlay/MediaCloudOverlay";
import VivabeautifulWoff from "assets/fonts/vivabeautiful.woff";
import VivabeautifulWoff2 from "assets/fonts/vivabeautiful.woff2";
import HagridRegular from "assets/fonts/Hagrid-Regular.woff2";
import HagridBlack from "assets/fonts/Hagrid-Black.woff2";
import HagridExtrabold from "assets/fonts/Hagrid-Extrabold.woff2";
import HagridHeavy from "assets/fonts/Hagrid-Heavy.woff2";
import ClipPaths from "components/Clippaths/Clippaths";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const App: FunctionComponent = () => {
    const dispatch = useDispatch<AppThunkDispatch>();
    const navigate = useNavigate();
    const location = useLocation();

    const overlay = useSelector((state: DefaultRootState) => state.overlay);

    useTagManager(navigate, location);

    // TODO: ErrorBoundary
    // TODO: Tag Manager (Maybe React.Memo)
    // TODO: Cookie Consent

    useEffect(() => {
        let languageUrl = "/";

        try {
            let language = location.pathname.toLowerCase().split("/");

            if (language.length > 0) {
                language = language.filter((value) => {
                    return value !== "";
                });
            }

            switch (language.length > 0 ? language[0] : "") {
                case "en":
                case "en-us":
                case "en-gb":
                    dispatch(thunkSetLocale("/en", "en"));
                    languageUrl = "/en";
                    break;
                case "de":
                case "de-AT":
                case "de-BE":
                case "de-DE":
                case "de-LI":
                case "de-LU":
                case "de-CH":
                    dispatch(thunkSetLocale("/de", "de"));
                    languageUrl = "/de";
                    break;
                default:
                    dispatch(thunkSetLocale("/", "da"));
                    languageUrl = "/";
                    break;
            }

            dispatch(thunkGetCategories(languageUrl));
            dispatch(thunkGetSiteSettings(languageUrl));
            dispatch(thunkLoadDictionary(languageUrl));
        } catch {
            // eslint-disable-next-line no-console
            console.warn("Error setting locale");
        }
    }, []);

    return (
        <Fragment>
            <GoogleReCaptchaProvider reCaptchaKey="6LcIk2wkAAAAAIYukBYv-rjviqIuD7-m2cFyTuVG">
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                        @font-face {
                            font-family: 'VivaBeautiful';
                            src: url(${VivabeautifulWoff}) format('woff'),
                                 url(${VivabeautifulWoff2}) format('woff2');
                            font-weight: 400;
                            font-style: normal;
                            font-display: swap;
                        }

                        @font-face {
                            font-family: 'Hagrid';
                            src: url(${HagridRegular}) format('woff2');
                            font-weight: 400;
                            font-style: normal;
                            font-display: swap;
                        }

                        @font-face {
                            font-family: 'Hagrid';
                            src: url(${HagridHeavy}) format('woff2');
                            font-weight: 700;
                            font-style: normal;
                            font-display: swap;
                        }


                        @font-face {
                            font-family: 'Hagrid';
                            src: url(${HagridBlack}) format('woff2');
                            font-weight: 200;
                            font-style: normal;
                            font-display: swap;
                        }

                        @font-face {
                            font-family: 'Hagrid';
                            src: url(${HagridExtrabold}) format('woff2');
                            font-weight: 800;
                            font-style: normal;
                            font-display: swap;
                        }

                        @font-face {
                            font-family: 'Hagrid';
                            src: url(${HagridHeavy}) format('woff2');
                            font-weight: 900;
                            font-style: normal;
                            font-display: swap;
                        }
                    `,
                    }}
                />

                <Header />

                <ClipPaths />
                <Routes>
                    <Route
                        path="*"
                        element={<UmbracoPage />}
                    />
                </Routes>

                {/* TODO: Make a new MEGA_DROPDOWN_MENU_CLOSING action to not have it close instant */}
                {overlay.currentOverlay === "MEGA_DROPDOWN_MENU" && overlay.content ? <MegaDropdown {...overlay.content} /> : null}

                {/* TODO: Make a new PRODUCTS_MENU_CLOSING action to not have it close instant */}
                {overlay.currentOverlay === "PRODUCTS_MENU" ? <Sidemenu view="FLOAT" /> : null}

                {/* TODO: Make a new MEDIA_CLOUD_DOWNLOAD_OVERLAY_CLOSING action to not have it close instant */}
                {overlay.currentOverlay === "MEDIA_CLOUD_DOWNLOAD_OVERLAY" ? <MediaCloudOverlay view="DOWNLOAD" /> : null}

                {/* TODO: Make a new MEDIA_CLOUD_EMAIL_OVERLAY_CLOSING action to not have it close instant */}
                {overlay.currentOverlay === "MEDIA_CLOUD_EMAIL_OVERLAY" ? <MediaCloudOverlay view="EMAIL" /> : null}

                <Footer />
            </GoogleReCaptchaProvider>
        </Fragment>
    );
};

export default App;
